// extracted by mini-css-extract-plugin
export var dropdownButton = "_43-0";
export var fullWidthDropdownButton = "_43-1";
export var icon = "_43-3";
export var iconPlaceholder = "_43-2";
export var menuItemRow = "_43-8";
export var separator = "_43-d";
export var shortcutContainer = "_43-7";
export var shortcutIconLg = "_43-6";
export var shortcutIconMd = "_43-5";
export var shortcutIconSm = "_43-4";
export var submenuChevron = "_43-c";
export var submenuDropdown = "_43-9";
export var submenuTriggerRow = "_43-a";
export var submenuTriggerRowOpen = "_43-b";